import React from 'react'
import NavWidget from '../../../../widget/Nav/NavWidget'
import SidebarWidget from '../../../../widget/SidebarWidget/SidebarWidget'
import DuesOnePageWidget  from './duesOnePageWidget'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
function DuesOne() {
  const { id } = useParams();

  return (
    <div>
        <NavWidget/>
        <div className='row'>
            <div className='col s12 m2 transparent'>
                <SidebarWidget/>
            </div>
            <div className='col s12 m10'>
                {/* <div className='container'> */}
                   <DuesOnePageWidget duesId={id}/>
                {/* </div> */}
            </div>
        </div>
    </div>
  )
}

export default DuesOne